// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__xJhsn","bigColWidth":"Table_bigColWidth__5BFPv","biggerColWidth":"Table_biggerColWidth__242CJ","row":"Table_row__3db_v","col":"Table_col__1-VW5"};